import { useState } from "react";
import { useTablesContext } from "../../../context/tablesContextProvider";
import { TableNames } from "../../../enums/tableNames";

export interface UseSearchTermReturn {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * Seeds the search box from the table's stored search text.
 *
 * @input tableName - Table whose search text to read; defaults to the non-ePA list
 * @return Search term state and its setter
 */
export const useSearchTerm = (
  tableName: TableNames = TableNames.CALLING_WORKLIST_ORDERS,
): UseSearchTermReturn => {
  const { getTableDataFromContext } = useTablesContext();

  const tableAttributes = getTableDataFromContext(tableName);

  const [searchTerm, setSearchTerm] = useState<string>(
    tableAttributes?.searchedText ?? "",
  );

  return {
    searchTerm,
    setSearchTerm,
  };
};
